export default "__VITE_ASSET__BtPw6W5y__"